<template>
    <BreadCrumb PageTitle="Ajouter une règle" />
    <AddRuleSet />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddRuleSet from "@/components/RulesSet/AddRuleSet.vue";
  
    export default defineComponent({
      name: "AddRuleSetPage",
      components: {
        BreadCrumb,
        AddRuleSet,
      },
    });
  </script>